import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { map } from 'rxjs';

export const slugGuard: CanActivateFn = route => {
  const apiService = inject(ApiService);
  const router = inject(Router);
  const slug = route.params['slug'];
  const type = route.url[0].path; // 'systems', 'reagents', or 'jobs'

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  return apiService.getBySlug(type, slug).pipe(
    map(exists => {
      if (exists) {
        return true;
      }
      router.navigate(['/404']);
      return false;
    }),
  );
};
